module.exports = __webpack_public_path__ + "img/notaFull-updated.2b424e6a.png";